import { createContext, useContext, useState } from "react";
import { DICT } from "./i18n";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { LoanTypes } from "./components/site/LoanTypes";
import { TrustBand } from "./components/site/TrustBand";
import { ApplicationForm } from "./components/site/ApplicationForm";
import { Reviews } from "./components/site/Reviews";
import { Footer } from "./components/site/Footer";

const LangContext = createContext(null);
export const useLang = () => useContext(LangContext);

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1713461983836-de0a45009424?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBhZHZpc29yJTIwY2xpZW50fGVufDB8fHx8MTc5MTk3MDc4OHww&ixlib=rb-4.1.0&q=85",
  personal: "https://images.unsplash.com/photo-1722487631997-cf1e0f92c2c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxob21lb3duZXIlMjBrZXlzJTIwcmVhbCUyMGVzdGF0ZXxlbnwwfHx8fDE3OTE5NzA3ODh8MA&ixlib=rb-4.1.0&q=85",
  business: "https://images.unsplash.com/photo-1622127739239-1905bbaa21b8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwzfHxlbnRlcnByaXNlJTIwd2FyZWhvdXNlJTIwbWFuYWdlcnxlbnwwfHx8MTc5MTk3MDc4OHww&ixlib=rb-4.1.0&q=85",
  band: "https://images.unsplash.com/photo-1629925526243-9062fb828146?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxrdWFsYSUyMGx1bXB1ciUyMHNreWxpbmUlMjBkdXNrfGVufDB8fHx8MTc5MTk3MDc4OHww&ixlib=rb-4.1.0&q=85",
};

function App() {
  // Visiting via an "admin." subdomain goes straight to the admin console
  if (window.location.hostname.startsWith("admin.")) {
    window.location.replace("/admin/");
  }
  const [lang, setLang] = useState("en");
  const t = (path) =>
    path.split(".").reduce((o, k) => (o != null ? o[k] : undefined), DICT[lang]) ?? path;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <div className="bg-[#070d1e] text-[#e2e8f0] min-h-screen overflow-x-hidden antialiased selection:bg-[#fbbf24] selection:text-[#070d1e]">
        <Nav />
        <Hero />
        <Marquee />
        <LoanTypes />
        <TrustBand />
        <ApplicationForm />
        <Reviews />
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </LangContext.Provider>
  );
}

export default App;
